import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { GalleryImageService } from '../../services/gallery-image.service';

@Component({
  selector: 'app-payment',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {


  constructor(
    private viewportScroller: ViewportScroller,
    private galleryService: GalleryImageService
  ) {
  }

  ngOnInit(): void {
  }


  public toAnchor(elementId: string): void {
      this.viewportScroller.scrollToAnchor(elementId);
  }

  openGalleryModeration(image: string) {
    this.galleryService.openGallery([image], 0);
  }
}
